import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const residenceDocumentStatus = enumerated({
  pending: 'Pendente',
  success: 'Sucesso',
  failed: 'Falhou',
})

export const residenceDocumentObject = z.object({
  id: z.string().uuid(),
  residenceId: z.string().uuid(),
  privateFileId: z.string().uuid().nullish(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  fileName: z.string().nullish(),
  mimeType: z.string().nullish(),
  status: residenceDocumentStatus,
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const residenceDocumentCreateInputObject = residenceDocumentObject
  .pick({
    id: true,
    residenceId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .extend({
    id: residenceDocumentObject.shape.id.nullish(),
    status: residenceDocumentObject.shape.status.nullish(),
  })

export const residenceDocumentUpdateInputObject = residenceDocumentObject
  .pick({
    id: true,
    residenceId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .partial()
  .required({ id: true })

export type ResidenceDocumentType = z.infer<typeof residenceDocumentObject>

export const propertyMap = {
  id: sql`residence_document.id`,
  residenceId: sql`residence_document.residence_id`,
  privateFileId: sql`residence_document.private_file_id`,
  gcsIdentifier: sql`residence_document.gcs_identifier`,
  url: sql`residence_document.url`,
  fileName: sql`residence_document.file_name`,
  mimeType: sql`residence_document.mime_type`,
  status: sql`residence_document.status`,
  clientId: sql`residence_document.client_id`,
  insertUserId: sql`residence_document.insert_user_id`,
  editUserId: sql`residence_document.edit_user_id`,
  createdAt: sql`residence_document.created_at`,
  updatedAt: sql`residence_document.updated_at`,
  synchronizedAt: sql`residence_document.synchronized_at`,
  deletedAt: sql`residence_document.deleted_at`,
}

export default residenceDocumentObject
